/**
 * Outlet Selector Component
 * Dropdown for selecting an outlet to view data from
 */

import { DropdownSelect } from '@components/common/DropdownSelect';
import { useAppDispatch, useAppSelector } from '@hooks/useRedux';
import {
  selectAllOutlets,
  selectAuthOutletId,
  selectCanUseCompanyScope,
  selectEffectiveOutlet,
  selectOutletSelectorValue,
  setSelectedOutletId,
} from '@store/outlets';
import React, { useEffect } from 'react';

export const OutletSelector: React.FC = () => {
  const dispatch = useAppDispatch();
  const outlets = useAppSelector(selectAllOutlets);
  const authOutletId = useAppSelector(selectAuthOutletId);
  const effectiveOutlet = useAppSelector(selectEffectiveOutlet);
  const selectorValue = useAppSelector(selectOutletSelectorValue);
  const canUseCompanyScope = useAppSelector(selectCanUseCompanyScope);

  useEffect(() => {
    if (outlets.length === 1) {
      dispatch(setSelectedOutletId(outlets[0].id));
    } else if (!canUseCompanyScope && authOutletId) {
      dispatch(setSelectedOutletId(authOutletId));
    } else if (!authOutletId) {
      dispatch(setSelectedOutletId(outlets.length > 0 ? outlets[0].id : null));
    }
  }, [authOutletId, canUseCompanyScope, dispatch, outlets]);

  if (!canUseCompanyScope) {
    if (!effectiveOutlet) return null;
    return (
      <DropdownSelect
        value={effectiveOutlet.id}
        onChange={() => {}}
        options={[{ value: effectiveOutlet.id, label: effectiveOutlet.name }]}
        disabled
      />
    );
  }

  if (!outlets.length) return null;

  const options = [
    ...(canUseCompanyScope ? [{ value: '', label: 'All Outlets' }] : []),
    ...outlets.map((o) => ({ value: o.id, label: o.name })),
  ];

  return (
    <DropdownSelect
      value={selectorValue ?? ''}
      onChange={(v) => dispatch(setSelectedOutletId(v || null))}
      options={options}
    />
  );
};
